import { useAppStore } from '@/stores/app';

/** Считаем, что пользователь системы является контрагентом, если
 * он авторизовался через форму входа в ЛК Контрагента через код (isAuthByEntryCode).
 * В будущем планируется добавить роль contractor и дать возможность авторизации
 * через форму входа tms с логином и паролем
 * useUserStore().user?.systemRole === EUserSystemRole.contractor || */
export const isCurrentUserContractor = (): boolean => useAppStore().isAuthByEntryCode;
